export const configEnv = {
    nftMinterContract:'0x0ddd2f552497820ef93f1c1674c41989f882722b',
    USDCContract:'0x21eC9c22a9FB84C716C6BE36eA7884eB72f86b17',
    nftPackAddress:'0x87CD8f3FFF26C806b3F960a546EC2161FEf9605B',
    rpc:'https://data-seed-prebsc-1-s1.binance.org:8545/',
    chainId:97,
    networkName:'BSC Testnet'
}